import React from "react";
var __jsx = React.createElement;
import get from 'lodash/get';
import { useSnackbar } from 'notistack';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { DeleteDialog } from 'components/common/DeleteDialog';
import FormBuilder from 'components/content/FormBuilder';
import { remainder } from 'libs/common/utils';
import { Trash } from 'theme/icons';
import SlidePosition from '../SlidePosition';
import Thumbnails from '../Thumbnails';
import { CarouselContent, Container, IconContainer, Insert, LeftArrow, PlusIcon, RemoveField, RightArrow, SlideContainer, ThumbnailsContainer } from './Carousel.style';

var Carousel = function Carousel(_ref) {
  var repeatedFields = _ref.repeatedFields,
      remove = _ref.remove,
      move = _ref.move,
      insert = _ref.insert,
      append = _ref.append,
      repeatableFieldName = _ref.repeatableFieldName,
      fieldPreviewUrlPath = _ref.fieldPreviewUrlPath;

  var _useState = useState(0),
      displayedFieldIndex = _useState[0],
      setDisplayedFieldIndex = _useState[1];

  var intl = useIntl();

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useState2 = useState(false),
      isRemoveModalOpen = _useState2[0],
      setIsRemoveModalOpen = _useState2[1];

  var _useState3 = useState(undefined),
      indexToRemove = _useState3[0],
      setIndexToRemove = _useState3[1];

  var slides = useWatch({
    name: repeatableFieldName
  });
  var displayNextField = useCallback(function () {
    setDisplayedFieldIndex(remainder(displayedFieldIndex + 1, repeatedFields.length));
  }, [displayedFieldIndex, repeatedFields.length]);
  var displayPreviousField = useCallback(function () {
    setDisplayedFieldIndex(remainder(displayedFieldIndex - 1, repeatedFields.length));
  }, [displayedFieldIndex, repeatedFields.length]);
  var handleRemove = useCallback(function () {
    repeatedFields.length === 1 && append({});
    setIndexToRemove(displayedFieldIndex); // Otherwise select input (position) will break

    displayedFieldIndex === repeatedFields.length - 1 && displayPreviousField();
  }, [displayedFieldIndex, displayPreviousField, repeatedFields.length, append]); // To avoid side effect when removing the only slide

  useEffect(function () {
    indexToRemove !== undefined && remove(indexToRemove);
    setIndexToRemove(undefined);
  }, [indexToRemove, remove, setIndexToRemove]);
  var onInsert = useCallback(function () {
    if (insert !== undefined) {
      insert(displayedFieldIndex + 1, {});
      setDisplayedFieldIndex(displayedFieldIndex + 1);
    }
  }, [insert, setDisplayedFieldIndex, displayedFieldIndex]);
  var previewUrls = useMemo(function () {
    return slides !== undefined ? slides.map(function (slide) {
      return get(slide, fieldPreviewUrlPath);
    }) : Array(repeatedFields.length).map(function () {
      return undefined;
    });
  }, [slides, repeatedFields.length, fieldPreviewUrlPath]);

  var moveSlide = function moveSlide(from, to) {
    move(from, to);
    setDisplayedFieldIndex(to);
  };

  return __jsx(Container, null, __jsx(IconContainer, {
    visible: repeatedFields.length > 1,
    title: intl.formatMessage({
      id: 'repeatable-fields.previous-repeated-field'
    }),
    onClick: displayPreviousField
  }, __jsx(LeftArrow, null)), __jsx(CarouselContent, null, __jsx(ThumbnailsContainer, null, __jsx(Thumbnails, {
    previewUrls: previewUrls,
    selectField: setDisplayedFieldIndex
  }), insert && __jsx(Insert, {
    title: intl.formatMessage({
      id: 'form.insert'
    }),
    onClick: onInsert
  }, __jsx(PlusIcon, null))), repeatedFields.map(function (repeatedField, index) {
    return __jsx(SlideContainer, {
      key: repeatedField.key,
      display: index === displayedFieldIndex ? 'block' : 'none'
    }, __jsx(SlidePosition, {
      displayedFieldIndex: displayedFieldIndex,
      repeatedFieldsCount: repeatedFields.length,
      moveSlide: moveSlide
    }), __jsx(FormBuilder, {
      formFields: [repeatedField]
    }), __jsx(RemoveField, {
      title: intl.formatMessage({
        id: 'form.remove'
      }),
      onClick: function onClick() {
        return setIsRemoveModalOpen(true);
      }
    }, __jsx(Trash, null)));
  }), __jsx(DeleteDialog, {
    open: isRemoveModalOpen,
    messageId: "repeatable-fields.disclaimer",
    onClose: function onClose() {
      return setIsRemoveModalOpen(false);
    },
    onConfirm: function onConfirm() {
      setIsRemoveModalOpen(false);
      handleRemove();
      enqueueSnackbar(intl.formatMessage({
        id: 'repeatable-fields.removed'
      }), {
        variant: 'success'
      });
    }
  })), __jsx(IconContainer, {
    visible: repeatedFields.length > 1,
    title: intl.formatMessage({
      id: 'repeatable-fields.next-repeated-field'
    }),
    onClick: displayNextField
  }, __jsx(RightArrow, null)));
};

export default Carousel;